/*** IMPORTS FROM imports-loader ***/
(function() {

/* global Api */

require('./template_selector');

(() => {
  const global = window.gl || (window.gl = {});

  class BlobDockerfileSelector extends gl.TemplateSelector {
    requestFile(query) {
      return Api.dockerfileYml(query.name, this.requestFileSuccess.bind(this));
    }

    requestFileSuccess(file) {
      return super.requestFileSuccess(file);
    }
  }

  global.BlobDockerfileSelector = BlobDockerfileSelector;
})();

}.call(window));


// WEBPACK FOOTER //
// ./blob/blob_dockerfile_selector.js.es6